import React from 'react';
import Card from '../components/Card';
import { useData } from '../context/DataContext';
import TagsHoc from '../components/hoc/TagsHoc';
import { useFavorites } from '../context/FavoritesContext';
import { RouteComponentProps } from 'react-router';
import { useQueryStrings } from '../context/QueryStringContext';
import Popup from '../components/Popup';
import { useApp } from '../context/AppContext';
import { getOptimizedEdpImageUrl } from '../../../../../../../shared/lib/image';
import { DailyProgramOffer } from '../../../../../../../shared/types/dailyProgram';

interface OfferDetailsPagePropsBase {
  offer?: DailyProgramOffer;
}

type OfferDetailsPageProps = OfferDetailsPagePropsBase & RouteComponentProps;

export default function OfferDetailsPage(props: OfferDetailsPageProps) {
  const { todayLineup } = useData();
  const { favorites, toggleFavorite } = useFavorites();
  const { updateQs } = useQueryStrings();
  const { config } = useApp();

  const { offer } = props;
  const venue = todayLineup.venues.find(venue => venue.templateId === offer?.venueId);

  return (
    <Popup onClose={() => updateQs('offer', undefined)}>
      {offer && (
        <div className="border-b border-slate-300 popup-container">
          <TagsHoc type="basic" item={offer} key={offer.id}>
            {props => (
              <Card
                detailed
                title={offer.title}
                subtitle={offer.description}
                image={getOptimizedEdpImageUrl(
                  offer.images,
                  offer.imageOptimizations,
                  config.imgRequirements,
                  0
                )}
                tags={props.tags}
                isFavorite={!!favorites.offers[offer.id]}
                callToActions={offer.callToActions}
                onFavoriteClick={() => toggleFavorite({ type: 'offers', value: offer })}
              />
            )}
          </TagsHoc>
          <hr className="border-slate-300 divider" />
          {venue && config.enabledViews.includes('explore') && (
            <TagsHoc type="venue" item={venue} key={venue.templateId}>
              {props => (
                <Card
                  onClick={() => updateQs('venue', venue.templateId)}
                  title={venue.venueString}
                  subtitle={venue.timeStrings}
                  image={getOptimizedEdpImageUrl(
                    venue.images,
                    venue.imageOptimizations,
                    config.imgRequirements,
                    0
                  )}
                  tags={props.tags}
                />
              )}
            </TagsHoc>
          )}
        </div>
      )}
    </Popup>
  );
}
